import React from 'react';
import { CartProductListing, CartProductListingTheme } from '../cart-pdct-listing';
import { toTitleText } from '../../../../framework/utils/string';
import { DoorType } from '../../../../entities-generated/common/door-type';
import { IDoorInstallationModel } from '../../../../entities-generated/models/project/door-installation-model';

interface ICartDoorListingProps {
  door: IDoorInstallationModel;
  suppressNotification: boolean;
  onSelected: () => void;
  onExclude: (() => void) | undefined;
  onInclude: () => void;
}

export const CartDoorListing: React.FunctionComponent<ICartDoorListingProps> = (props) => {
  const { door } = props;
  const title = door.isExcluded
    ? 'Removed From Project'
    : !!door.selectedDoor
      ? door.selectedDoor.description : 'Awaiting Selection';

  return (
    <CartProductListing
      theme={!!door.selectedDoor && door.isExcluded === false ? CartProductListingTheme.Primary : CartProductListingTheme.Grayscale}
      label={toTitleText(DoorType[door.doorType])}
      variant={door.isExcluded === false ? door.selectedDoor?.textureVariant : undefined}
      showNotification={door.priceChange !== 0 && props.suppressNotification === false}
      pricing={!!door.selectedDoor && door.isExcluded === false ? door.selectedDoorPrice : undefined}
      title={title}
      imageUrl={door.selectedDoor?.textureVariant.productImageUrl}
      onExclude={door.isExcluded === false ? props.onExclude : undefined}
      onInclude={door.isExcluded ? props.onInclude : undefined}
      onSelected={!!door.selectedDoor ? props.onSelected : undefined}
    />
  );
};